import React from 'react';
import MortgageForm from "../../../../../components/data-capture/MortgageForm";

function ApplicationForm({section, inExtWindow=true}) {

    let target = section.applicant === 1 ? `applicant1` : `applicant2`
    target += `.assets[${section.index}]`

    let jointQuestions = [
        {
            name: 'joint',
            label: 'Joint Acc',
            answer: {
                type: 'select',
                choices: [
                    {
                        value: true,
                        text: 'Yes'
                    }, {
                        value: false,
                        text: 'No'
                    }
                ]

            },
            target: `${target}[${section.index}].joint`
        }, {
            name: 'currency',
            label: 'Currency',
            answer: {
                type: 'text'
            },
            target: `${target}.currency`
        },
    ]

    let questions = [
        [{
            name: 'institution',
            label: 'Bank Name',
            answer: {
                type: 'text',
            },
            target: `${target}.institution`
        },
            {
                name: 'description',
                label: 'Description',
                answer: {
                    type: 'text',
                },
                target: `${target}.description`
            },
            {
            name: 'accountNumber',
            label: 'IBAN',
            answer: {
                type: 'text',
            },
            target: `${target}.accountNumber`
        }], jointQuestions, [

            {
                name: 'isClosed',
                label: 'Is Closed',
                answer: {
                    type: 'select',
                    choices: [
                        {
                            value: true,
                            text: 'Yes'
                        }, {
                            value: false,
                            text: 'No'
                        }
                    ]
                },
                target: `${target}.isClosed`
            }, {
                name: 'isNewAccount',
                label: 'Is New Account',
                answer: {
                    type: 'select',
                    choices: [
                        {
                            value: true,
                            text: 'Yes'
                        }, {
                            value: false,
                            text: 'No'
                        }
                    ]

                },
                target: `${target}.isNewAccount`
            }

        ]
    ]
    return (
        <MortgageForm inExtWindow={inExtWindow} questions={questions}/>
    );
}

export default ApplicationForm;